// ** react imports
import React from 'react';

// ** routers imports
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// ** utils imports
import SessionStorage from '../../utils/SessionStorage';

const AuthLayout = () => {
  // hooks
  const location = useLocation();
  const token = SessionStorage.get('token');

  return token ? (
    <Navigate to="/users/list" state={{ from: location }} replace />
  ) : (
    <Outlet />
  );
};

export default AuthLayout;
